import PostsAdapter from './base';

export default class Communitynotice extends PostsAdapter {
  modelNamePlural = 'communitynotices';
}
